import { useFetcher } from '@/api/useFetcher.ts';
import { useQuery } from '@tanstack/react-query';
import { GetLostHoursResponse, Routes } from '@/api/types.ts';

export const useLostHoursListQuery = () => {
  const fetchData = useFetcher();

  return useQuery<GetLostHoursResponse>({
    queryKey: [Routes.LostHours],
    queryFn: () => fetchData(Routes.LostHours),
  });
};
